import { render, staticRenderFns } from "./vehicleDisassemblyBulk.vue?vue&type=template&id=674fc987&scoped=true"
import script from "./vehicleDisassemblyBulk.vue?vue&type=script&lang=js"
export * from "./vehicleDisassemblyBulk.vue?vue&type=script&lang=js"
import style0 from "./vehicleDisassemblyBulk.vue?vue&type=style&index=0&id=674fc987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fc987",
  null
  
)

export default component.exports